export const noticeLinks = {
  AZ: 'notices',
  NV: '',
  NM: 'notices_new_mexico',
};

export const evictionLinks = {
  AZ: 'evictionintakeform',
  NV: '',
  NM: 'evictionintakeform/NM',
};
